export const environment = {
  production: false,
  mode: 'development',

  backendUri: 'https://api.acwa-connect.com',
  backendOAuthClientId: '2_2x1sy5f06rggs0g0sk48444o0oc4sow0ssoww8ocgkow0scg0s',
  backendOAuthClientSecret:
    '3ti0ooi72g4kgcwwogg4c40wwg0ogk84wsoo8okcocgcw80ok0',

  videoBaseUri: 'https://s3.fr-par.scw.cloud/acwa.connect.video/',

  configurateurUri: 'https://www.e-dro.io/configurateur-app/',
  configurateurProductUri: 'https://www.e-dro.io/configurateur-app/products/',
};
